import { render } from "./phone-field.vue?vue&type=template&id=df9264fc"
import script from "./phone-field.vue?vue&type=script&lang=js"
export * from "./phone-field.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__